// src/pages/GalleryPage.js
import React from 'react';
import styles from '../css/GalleryPage.module.css';

const GalleryPage = () => {
  // Resim yollarını ve kategorilerini buraya ekle
  // Not: Resimlerin public/assets/img/gallery/ içinde olduğunu varsayıyorum
  const galleryImages = [
    { id: 1, src: '/assets/img/huzurfoto1.jpeg', title: 'Motor Revizyon', category: 'Tamir' },
    { id: 2, src: '/assets/img/huzurfoto2.jpeg', title: 'Özel Boya İşlemi', category: 'Modifiye' },
    { id: 3, src: '/assets/img/huzurfoto3.jpeg', title: 'Zincir & Dişli Değişimi', category: 'Bakım' },
  ];

  return (
    <section className={styles.gallerySection} id="gallery">
      <div className={styles.header}>
        <span className={styles.badge}>AKC Motor Garajı</span>
        <h2>Atölyemizden <span>Kareler</span></h2>
        <div className={styles.underline}></div>
      </div>

      <div className={styles.grid}>
        {galleryImages.map((item) => (
          <div key={item.id} className={styles.galleryItem}>
            <div className={styles.imageWrapper}>
              <img src={item.src} alt={item.title} />
              <div className={styles.overlay}>
                <span className={styles.category}>{item.category}</span>
                <h3>{item.title}</h3>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default GalleryPage;